module.exports = __webpack_public_path__ + "img/favicon-projets-urbains.d13294d3.png";